import { promiseAction } from 'utils/store';

export const GIFTS_ACTION_TYPES = {
  GIFTS_CATEGORIES_LOAD: 'gifts/GIFTS_CATEGORIES_LOAD',
  GIFTS_CATEGORIES_CREATE: 'gifts/GIFTS_CATEGORIES_CREATE',
  GIFTS_CATEGORIES_DELETE: 'gifts/GIFTS_CATEGORIES_DELETE',
  GIFTS_CATEGORIES_EDIT: 'gifts/GIFTS_CATEGORIES_EDIT',
  GIFTS_LOAD: 'gifts/GIFTS_LOAD',
  GIFTS_EDIT: 'gifts/GIFTS_EDIT',
  GIFTS_CREATE: 'gifts/GIFTS_CREATE',
}

export const loadGiftsCategoriesAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_LOAD)
export const createGiftsCategoryAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_CREATE)
export const deleteGiftsCategoryAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_DELETE)
export const editGiftsCategoryAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_CATEGORIES_EDIT)
export const createGiftAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_CREATE)
export const editGiftAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_EDIT)
export const loadGiftsAction = promiseAction(GIFTS_ACTION_TYPES.GIFTS_LOAD)